
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["isConnected","connect","disconnect","commandToArray","sendCommand","authorize","request"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "fbf3d361cbedc76818a5.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			